// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".set-consist[data-v-9448cf22]{font-size:14px;display:flex;flex-direction:column}.consist-detail[data-v-9448cf22]{display:flex;flex-wrap:wrap;gap:12px}.consist-detail__item[data-v-9448cf22]{width:calc(50% - 6px)}@media(max-width: 620px){.consist-detail__item[data-v-9448cf22]{width:100%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
